import React from 'react';

const IconWindowsOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 512 512"
    fill="none"
    stroke="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-windows-outline">
    <path
      fill="currentColor"
      d="M227.302,38.289v202.282h268.59V-2L227.302,38.289z M479.105,223.784H244.089V52.557l235.016-34.413V223.784z"
    />
    <path
      fill="currentColor"
      d="M0.679,243.089h209.836V39.967L0.679,71.023V243.089z M17.466,85.292l176.262-26.02v167.03H17.466V85.292z"
    />
    <path
      fill="currentColor"
      d="M227.302,456.282l268.59,40.289V259.875h-268.59V456.282z M244.089,276.662h235.016v200.603l-235.016-35.253V276.662z"
    />
    <path
      fill="currentColor"
      d="M0.679,423.548l209.836,31.056V259.875H0.679V423.548z M17.466,276.662h176.262v158.636l-176.262-26.02V276.662z"
    />
  </svg>
);

export default IconWindowsOutline;
